import { InputHasLabelError } from 'components/Input/InputVariants';
import ReactPhoneNumberInput from 'react-phone-number-input/basic-input';

const PhoneInput = props => (
  <InputHasLabelError {...props} Component={ReactPhoneNumberInput} />
);

export default PhoneInput;
